import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Shield } from 'lucide-react';

export const Privacy: React.FC = () => {
  return (
    <main className="flex-grow container mx-auto px-4 py-8">
      <Helmet>
        <title>Privacy Policy - Asphalt Calculator</title>
        <meta name="description" content="Privacy policy for the Asphalt Calculator website. Learn how we protect and handle your data." />
      </Helmet>

      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-xl p-8">
        <div className="flex items-center mb-8">
          <Shield className="h-8 w-8 text-blue-600 mr-3" />
          <h1 className="text-3xl font-bold text-slate-800">Privacy Policy</h1>
        </div>

        <div className="prose max-w-none">
          <p className="text-slate-600 mb-6">Last updated: {new Date().toLocaleDateString()}</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Information We Collect</h2>
            <p className="text-slate-600 mb-4">
              We collect information that you voluntarily provide when using our calculator, including:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Calculation inputs and results</li>
              <li>Browser type and version</li>
              <li>Device information</li>
              <li>IP address</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">How We Use Your Information</h2>
            <p className="text-slate-600 mb-4">
              We use the collected information to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Provide and improve our calculator service</li>
              <li>Analyze usage patterns</li>
              <li>Maintain and enhance site security</li>
              <li>Communicate important updates</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Data Security</h2>
            <p className="text-slate-600 mb-4">
              We implement appropriate security measures to protect your information against unauthorized access,
              alteration, disclosure, or destruction.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Third-Party Services</h2>
            <p className="text-slate-600 mb-4">
              We may use third-party services for:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Analytics (Google Analytics)</li>
              <li>Advertising (Google AdSense)</li>
              <li>Performance monitoring</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Your Rights</h2>
            <p className="text-slate-600 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4">
              <li>Access your personal information</li>
              <li>Request correction of your data</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of data collection</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contact Us</h2>
            <p className="text-slate-600">
              If you have any questions about this Privacy Policy, please contact us at:
              <br />
              Email: info@asphaltcalculator.online
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};